import React, {useState, useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import api from "../../api/api";
import sidebar from "../../pages/staffSidebar/Array";
import CompanyEdit from "../../pages/staffSidebar/CompanyDetails/CompanyEdit";



const SideBarLayout = () => {

  const [newSidebar, setNewSidebar] = useState([]);

  // retrieving permission based on user
  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    api 
      .get("/users/me/")
      .then((response) => {
        let perms = response.data[0].groups[0].permissions

        let obj = [];
        perms
          .map((item) => item.model)
          .filter((perm, i) => {
            if (i === 0) {
              obj.push(perm);
            } else {
              if (perm === perm[i - 1]) {
                obj.push(perm);
              }
            }
          });

        setPermissions(obj);
      })
      .catch((error) => {});
  }, []);

  
  // based on permission create new sidebar
  useEffect(() => {
  
    const user = JSON.parse(localStorage.getItem("user"));

    if(permissions.length > 0 ) {
      
    let newData = sidebar.map((item, i) => {
  
      let childrens = [];

      item?.chidren?.map((child) => {
        if (permissions.includes(child.model) || child.model === "all") {
          childrens.push(child);
        }
      });

      if(childrens.length > 0) {
        item.chidren = childrens;
        return item;
      }else{
        return null
      }
      
    });

    let newBar =  newData.filter(item => item !== null)

    setNewSidebar(newBar)

  }else if(user.user_type === "AD") {
    setNewSidebar(sidebar)
  }
   
  }, [permissions, sidebar]);



  return (
    <div>
      {newSidebar.map((item) =>
        item.chidren.map((list, i) => {
          return (
            <div key={i}>
              <Routes>
                <Route path={`/${list.link}`}
                 element={<list.component />} />

              <Route  path={`/${list.link}/company-edit`} element={<CompanyEdit/>}/>
              </Routes>
              
             </div>
          );
        })
        )}
       
    </div>
  );
};

export default SideBarLayout;
